import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import "react";
function Skeleton({ className, ...properties }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('animate-pulse rounded-md bg-primary/10', className),
        ...properties
    });
}
export { Skeleton };

//# sourceMappingURL=index.js.map